module.exports = __webpack_public_path__ + "static/media/privacy.9d06dcfb.md";